/**
 * Search Modal Position Controller
 * Positions search modal correctly based on announcement bar visibility
 */

class SearchModalPositioner {
  constructor() {
    this.modal = null;
    this.headerGroup = null;
    this.announcementBar = null;
    this.header = null;
    this.ticking = false;
    this.init();
  }

  init() {
    // Get all required elements
    this.modal = document.querySelector('dialog-component#search-modal');
    this.headerGroup = document.getElementById('header-group');

    if (!this.modal || !this.headerGroup) {
      setTimeout(() => this.init(), 100);
      return;
    }

    // Find announcement bar (first child of header-group that's a section or div)
    const children = this.headerGroup.children;
    if (children.length > 0) {
      this.announcementBar = children[0]; // Usually announcement section
      this.header = children[1]; // Usually header section
    }

    // Listen for modal open/close
    const observer = new MutationObserver(() => {
      this.updatePosition();
    });

    observer.observe(this.modal, {
      attributes: true,
      subtree: true,
      attributeFilter: ['open']
    });

    // Update on scroll
    window.addEventListener('scroll', () => this.updatePosition(), { passive: true });
    window.addEventListener('resize', () => this.updatePosition());

    this.updatePosition();
  }

  getAnnouncementHeight() {
    if (!this.announcementBar) return 0;

    // Check if announcement is visible (top of viewport)
    const rect = this.announcementBar.getBoundingClientRect();

    // If announcement is at top and visible, return its height
    if (rect.top <= 0 && rect.bottom > 0) {
      return Math.round(rect.bottom);
    }

    return 0; // Announcement scrolled away
  }

  getHeaderHeight() {
    // Header is always 60px (or similar)
    // Use fixed value for reliability
    return 60;
  }

  getModalPosition() {
    const announcementHeight = this.getAnnouncementHeight();
    const headerHeight = this.getHeaderHeight();

    // Total position = announcement (if visible) + header
    return announcementHeight + headerHeight;
  }

  updatePosition() {
    if (!this.modal) return;

    const modalContent = this.modal.querySelector('.search-modal__content');
    if (!modalContent) return;

    // Check if modal is open
    const dialog = this.modal.querySelector('dialog[open]');
    if (!dialog) return;

    if (this.ticking) return;

    this.ticking = true;
    requestAnimationFrame(() => {
      const topPosition = this.getModalPosition();
      const maxHeight = `calc(100vh - ${topPosition}px)`;

      // Set position and height
      modalContent.style.top = `${topPosition}px`;
      modalContent.style.maxHeight = maxHeight;

      this.ticking = false;
    });
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.searchModalPositioner = new SearchModalPositioner();
  });
} else {
  window.searchModalPositioner = new SearchModalPositioner();
}
